import { render, staticRenderFns } from "./Header.vue?vue&type=template&id=0a5fdd6a&"
import script from "./Header.vue?vue&type=script&lang=js&"
export * from "./Header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/foxik0169/Projects/rattlecinake.com/themes/ultimatefilms/assets/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('0a5fdd6a', component.options)
    } else {
      api.reload('0a5fdd6a', component.options)
    }
    module.hot.accept("./Header.vue?vue&type=template&id=0a5fdd6a&", function () {
      api.rerender('0a5fdd6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/partials/Header.vue"
export default component.exports